import styled from 'styled-components';

export const Content = styled.div`
  min-height: 400px;
`;

export default Content;
